<template>
  <v-container fluid class="full-container d-flex flex-column">
    <v-row>
      <v-col cols="12">
        <v-card class="secondary--text" min-height="100">
          <v-toolbar dark color="sleep">
            Support
            <v-spacer />
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item link @click="showTaskForm = true">
                  <v-list-item-title>Create task</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-row>
            <v-col cols="5" class="pb-0">
              <v-card-title v-if="user">
                <v-avatar size="35" color="error" class="align-self-center">
                  <img v-if="user.userProfile.profilePicture" :src="user.userProfile.profilePicture" />
                  <span v-else class="white--text headline">{{ `${user.firstName[0]} ${user.lastName[0]}` }}</span>
                </v-avatar>

                <h3 class="ml-2">{{ user.firstName }} {{ user.lastName }}</h3>
                <h5 class="ml-5">Today: {{ $moment() | moment("YYYY-MM-DD") }}</h5>
              </v-card-title>
              <v-card-title class="pt-0" v-if="myUsers">
                <span class="mx-2">
                  <v-icon color="secondary">mdi-circle-outline</v-icon>
                  {{ myUsers.tasksOutstanding }}
                </span>
                <span class="mx-2">
                  <v-icon color="green">mdi-check-circle-outline</v-icon>
                  {{ myUsers.tasksCompleted }}
                </span>
              </v-card-title>
            </v-col>
            <v-col cols="12" class=" mt-0 pt-0">
              <v-row class="px-4 pt-0">
                <v-col cols="4" class="py-0">
                  <v-select
                    v-model="selectedStages"
                    :items="stages"
                    label="Task stage"
                    single-line
                    dense
                    chips
                    multiple
                  />
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-autocomplete
                    v-if="staff"
                    v-model="assignedToId"
                    class="ml-2 pt-1"
                    item-text="name"
                    item-value="id"
                    label="Assigned to"
                    clearable
                    dense
                    filled
                    outlined
                    small-chips
                    solo
                    rounded
                    :items="staff"
                  >
                    <template v-slot:selection="data">
                      <v-chip v-bind="data.attrs" :input-value="data.selected">
                        <v-avatar left>
                          <v-img :src="data.item.avatar"></v-img>
                        </v-avatar>
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-avatar>
                        <img :src="data.item.avatar" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showTaskForm"
      persistent
      class="limited-height"
      width="900"
      transition="dialog-bottom-transition"
    >
      <task-form @close="showTaskForm = false" @created="refetch()" />
    </v-dialog>

    <v-row class="flex-grow-1 fill-height overflow-auto">
      <v-col cols="4" lg="3" class="fill-height overflow-auto">
        <v-sheet rounded class="px-1 py-1 ">
          <div class="d-flex justify-space-between">
            <h2 class="primary--text ml-2">
              {{ assignedToId ? "Support tasks" : "Unassigned support tasks" }} - {{ taskEvents.length }}
            </h2>
          </div>

          <v-card class="overflow-auto" elevation="0">
            <div v-if="taskEvents.length == 0" class="text-h6 ml-5 mt-3 grey-navy--text">
              No tasks
            </div>

            <div v-for="taskEvent in taskEvents" :key="taskEvent.node.id">
              <v-hover v-slot="{ hover }">
                <v-card
                  class="my-2 fake-link d-flex"
                  :elevation="hover || selectedEvent == taskEvent.node ? 6 : 0"
                  :class="selectedEvent == taskEvent.node ? 'user-selected' : ''"
                  tile
                  @click="selectTask(taskEvent.node)"
                >
                  <div class="align-self-center">
                    <v-icon color="green" v-if="taskEvent.node.closedAt">mdi-check-circle-outline</v-icon>
                    <v-icon v-else :color="taskEvent.node.snoozeUntil ? 'selection' : 'grey'"
                      >mdi-circle-outline</v-icon
                    >
                  </div>
                  <div class="d-flex flex-column flex-fill">
                    <v-card-subtitle class="pb-0 my-0 pt-2 d-flex justify-space-between">
                      {{ fancyShortDate(taskEvent.node.createdAt) }}
                      <span v-if="taskEvent.node.snoozeUntil"
                        ><v-icon color="selection">mdi-calendar</v-icon>
                        {{ taskEvent.node.snoozeUntil }}
                      </span>
                      <span>
                        <b>{{ taskEvent.node.stage.title }}</b>
                      </span>
                    </v-card-subtitle>
                    <v-card-title class="pt-0 d-flex d-flex">
                      <span class=" block font-weight-bold overline">
                        <span v-if="taskEvent.node.user" class="block">
                          {{ taskEvent.node.user.firstName }}
                          {{ taskEvent.node.user.lastName }}
                        </span>
                        {{ taskEvent.node.title }}
                      </span>
                    </v-card-title>
                    <v-card-subtitle class="d-flex">
                      <span>
                        {{ taskEvent.node.description.substr(0, 90) }}
                      </span>
                    </v-card-subtitle>
                  </div>
                  <div class="align-self-center mx-2">
                    <v-avatar v-if="taskEvent.node.assignedTo" size="40" color="error">
                      <img
                        v-if="taskEvent.node.assignedTo.userProfile.profilePicture"
                        :src="taskEvent.node.assignedTo.userProfile.profilePicture"
                      />
                      <span v-else class="white--text headline">{{
                        `${taskEvent.node.assignedTo.firstName[0]} ${taskEvent.node.assignedTo.lastName[0]}`
                      }}</span>
                    </v-avatar>
                  </div>
                </v-card>
              </v-hover>
            </div>
          </v-card>
        </v-sheet>
      </v-col>
      <v-col cols="4" class="fill-height overflow-auto">
        <task-details v-if="selectedEvent" :task="selectedEvent" />
        <template v-if="chatsForUser && chatsForUser.length > 0 && selectedEvent.user">
          <div class="d-flex justify-space-between pt-6">
            <h2 class="primary--text">Chats</h2>
          </div>
          <div v-for="chat in chatsForUser" :key="chat.id">
            <chat-listing-card :chat="chat" :userId="selectedEvent.user.id" class="mt-2 mb-8" />
          </div>
        </template>
      </v-col>
      <v-col cols="4" lg="5" class="fill-height overflow-auto">
        <v-sheet rounded class="fill-height">
          <client-summary v-if="selectedEvent && selectedEvent.user" :userId="selectedEvent.user.id" />
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { extractNodes } from "@/lib/array";
import { MY_USERS_QUERY, TASK_EVENT_QUERY } from "@/graphql/queries/task";
import { STAGES_QUERY } from "@/graphql/queries/task";
import { ACCOUNT_QUERY } from "@/graphql/queries/user";
import { fancyShortDate } from "@/lib/fancy_date";
import { CHATS_FOR_USER } from "@/graphql/queries/chat";
import { STAFF_QUERY } from "@/graphql/queries/user";
import { decodeId } from "@/lib/string";
import { getUserName } from "@/lib/username";
import ClientSummary from "@/components/task/components/ClientSummary";
import TaskDetails from "@/components/task/components/TaskDetails";
import ChatListingCard from "@/components/chats/ChatListingCard";
import TaskForm from "@/components/task/components/TaskForm";

export default {
  name: "SupportTaskBase",
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    ClientSummary,
    TaskDetails,
    ChatListingCard,
    TaskForm,
  },
  data() {
    return {
      myUsers: [],
      selectedStages: [],
      taskEvents: [],
      showAllClients: false,
      showAllUserTasks: false,
      selectedEvent: null,
      assignedToId: null,
      staff: [],
      chatsForUser: [],
      showTaskForm: false,
    };
  },
  created() {
    this.assignedToId = this.userId;
  },

  methods: {
    selectTask(task) {
      this.selectedEvent = task;
    },
    refetch() {
      this.$apollo.queries.taskEvents.refetch();
    },
    fancyShortDate(date) {
      return fancyShortDate(date);
    },
    cardClasses(user) {
      let classes = [];
      if (user.id == this.selectedUserId) {
        classes.push("user-selected");
      }

      if (user.userProfile.activeSubscription && user.userProfile.activeSubscription.product.type) {
        if (user.userProfile.activeSubscription.product.type == "CLUB") {
          classes.push("club-border");
        }
        if (user.userProfile.activeSubscription.product.type == "ONE_ON_ONE") {
          classes.push("one-on-one-border");
        }
        if (user.userProfile.activeSubscription.product.type == "JEFF_MEMBER") {
          classes.push("life-border");
        }
      }

      return classes;
    },
  },
  apollo: {
    myUsers: {
      query: MY_USERS_QUERY,
      variables() {
        return {
          assigneeId: this.userId,
        };
      },
      fetchPolicy: "cache-and-network",
    },
    taskEvents: {
      query: TASK_EVENT_QUERY,
      variables() {
        let variables = {
          taskType_Title: "Support",
          recentlyCompletedAndOpen: true,
        };

        if (this.selectedStages.length > 0) {
          variables["stage_Id_In"] = this.selectedStages;
        }

        if (this.assignedToId) {
          variables["assignedToId"] = btoa("UserNode:" + this.assignedToId);
        } else {
          variables["assignedToId_Isnull"] = true;
        }
        return variables;
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        if (this.selectedEvent) {
          var selected = data.taskEvents.edges.find((evt) => evt.node.id == this.selectedEvent.id);
          if (selected) {
            this.selectedEvent = selected.node;
          }
        }
        return data.taskEvents.edges;
      },
    },
    user: {
      query: ACCOUNT_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
      fetchPolicy: "cache-and-network",
    },
    chatsForUser: {
      query: CHATS_FOR_USER,
      variables() {
        return {
          userId: this.selectedEvent.user.id,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        const chats = extractNodes(data.chatsForUser.edges);
        this.hasCoachingChat = chats.filter((chat) => chat.type == "COACH").length > 0;
        return chats.filter((chat) => chat.type !== "ACCOUNTABILITY");
      },
      skip() {
        return !this.selectedEvent || !this.selectedEvent.user?.id;
      },
    },
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              id: decodeId(item.node.id),
              name: getUserName(item.node),
              avatar: item.node.userProfile?.profilePicture,
            };

            this.staff.push(data);
          });

          this.staff.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
      },
    },
    stages: {
      query: STAGES_QUERY,
      update(data) {
        return data.stages.map((item) => {
          return {
            text: item.title,
            value: item.id,
          };
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.full-container {
  height: calc(100vh - 45px);
}

.user-selected {
  border-right: 8px solid blue;
}
</style>
